import { FC, useState } from 'react';
import { CustomCard } from '@mybonum/ui';

import { AppointmentsPopup, type TCustomerInfo } from './components/appointments-popup';
import { CustomersFilter } from './components/filter';
import { CustomersTable } from './components/table';
import { useColumns } from './hooks/use-columns.tsx';
import { TCustomerType } from './types.ts';

import { ColumnsVisibilityProvider } from '@/contexts/column-visibility';

export const Customers: FC = () => {
    const [customer, setCustomer] = useState<TCustomerInfo | null>(null);
    const [isAppointmentsPopupOpen, setIsAppointmentsPopupOpen] = useState(false);

    const handleAppointmentPopupOpen = (customerInfo: TCustomerInfo): void => {
        setCustomer(customerInfo);
        setIsAppointmentsPopupOpen(true);
    };

    const handleAppointmentPopupClose = (): void => {
        setIsAppointmentsPopupOpen(false);
        setCustomer(null);
    };

    const columns = useColumns({ onAppointmentsClick: handleAppointmentPopupOpen });

    return (
        <CustomCard>
            <ColumnsVisibilityProvider<TCustomerType>
                storageKey="customers_table"
                columns={columns}
                requiredColumnsKeys={['id', 'firstName']}
            >
                <CustomersFilter />
                <CustomersTable />
            </ColumnsVisibilityProvider>
            <AppointmentsPopup
                customer={customer}
                open={isAppointmentsPopupOpen}
                onClose={handleAppointmentPopupClose}
            />
        </CustomCard>
    );
};
